module.exports = __webpack_public_path__ + "media/assets/icons/phone-f9cd55cdc5b0db04cd9d7acb01943018.svg";